import {ActiveFiltersAdapter} from '../BaseFilterInterfaces';

/**
 * Adapter for Record<string, string> to work with BaseFilter
 * Converts object to adapter interface (single value per key)
 */
export function createRecordAdapter(record: Record<string, string>): ActiveFiltersAdapter {
  return {
    getAll(key: string): string[] {
      const value = record[key];
      return value ? [value] : [];
    },

    has(key: string): boolean {
      return key in record && record[key] !== '';
    },

    forEach(callback: (value: string, key: string) => void): void {
      Object.entries(record).forEach(([key, value]) => {
        if (value) {
          callback(value, key);
        }
      });
    },

    get(key: string): string | null {
      const value = record[key];
      return value || null;
    }
  };
}
